/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import BetForm from './betForm'
import * as stringParser from '../../util/string.util'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
import { DemoBetDelay } from '../../configs/casinoShowList';
import { SPECIFICCOMPETITIONID } from '../../configs/commonConfigs';
let oid = OPERATOR_ID.toLowerCase()
export default class InPlayMoEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            bid_at: 0,
            bid_for: "back",
            market: {},
            teams: [],
            eventMarket: {},
            evtMeta: {}
        };
    }
    componentWillUnmount() {
        if(!!this.props.socket){
            this.props.socket.off("market_room")
        }
    }
    componentDidMount() {
        const socket = this.props.socket;
        let eventMarket = !!this.props.event.markets && this.props.event.markets.length > 0 ? this.props.event.markets.filter((mkt, k) => {
            return mkt.marketType === "MATCH_ODDS"
        }) : []
        eventMarket = eventMarket.length > 0 ? eventMarket[0] : !!this.props.event.markets ? this.props.event.markets[0] : null
        if (!!eventMarket && !!eventMarket.marketBook) {
            let market = !!this.props.feedBooks[eventMarket.marketId] ? this.props.feedBooks[eventMarket.marketId] : eventMarket.marketBook
            // evtMeta = eventMarket.metadata.eventMeta
            this.setState({ market: market, teams: eventMarket.runners, evtMeta: eventMarket.metadata.eventMeta })
        }
        this.setState({ marketId: eventMarket.marketId })
        let stream = ""
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0) {
            if (this.props.subscribedMarkets.indexOf(eventMarket.marketId) === -1) {
                if (this.props.subscriptions.market_room.indexOf(eventMarket.marketId) === -1) {
                    this.props.subscribe('market_room', eventMarket.marketId)
                    socket.emit('market_room', eventMarket.marketId)
                    this.props.updateSubscribedMarkets(eventMarket.marketId)
                }
            }
            socket.on("market_room", data => {
                if (stream !== data) {
                    stream = data
                    let newBook = stringParser.deSrlz(data)
                    // newBook.evtMeta = eventMarket.metadata.eventMeta
                    if (eventMarket.marketId === newBook.marketId) {
                        this.props.updateBook(eventMarket.marketId, newBook)
                        let curBook = this.state.market
                        curBook.runners.forEach((rn, i) => {
                            let nrn = newBook.runners[i]
                            rn.back.forEach((bk, j) => {
                                if (!!nrn.back[j]) {
                                    if (bk.line !== nrn.back[j].line) {
                                        nrn.back[j].has_blink = true
                                    } else {
                                        nrn.back[j].has_blink = false
                                    }
                                }
                            })
                            rn.lay.forEach((ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.line !== nrn.lay[k].line) {
                                        nrn.lay[k].has_blink = true
                                    } else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                            newBook.runners[i] = nrn
                        });
                        this.setState({ market: newBook, evtMeta: eventMarket.metadata.eventMeta }, () => {
                            setTimeout(() => {
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) {
                                            nrn.lay[k].has_blink = false
                                        }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ market: newBook })
                            }, 500)
                        })
                    }
                }
            });
            socket.on('disconnect', () => {
                socket.emit('market_room', eventMarket.marketId)
            })
        }
    }
    selectBid(runner_name, bid_at, game_code, bid_for, event_index, team) {
        localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, bid_for: bid_for, selectionId: team.id }))
        this.setState({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, bid_for: bid_for, selectionId: team.id }, () => {
            this.props.betForm(game_code, event_index, "clicked")
        })
    }
    formatDate(date) {
        date = new Date(date)
        let month = [];
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sept";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        let mn = month[date.getMonth()];
        let dt = date.getDate();
        dt = dt > 9 ? dt : "0" + dt
        let hr = date.getHours();
        hr = hr > 9 ? hr : "0" + hr
        let min = date.getMinutes();
        min = min > 9 ? min : "0" + min

        let formatedDate = dt + " " + mn + " " + hr + ":" + min
        return formatedDate

    }
    
    addBetFn(dt, evt){

        dt.event_name = evt["name"]; 
        dt.marketId = this.state.marketId; 
        dt.selectionId = this.state.selectionId; 

        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt?.role === 'DemoClient'){
            this.props.togglebetLoader()    
                setTimeout(() => {    
                    let price = dt.price
                    this.state.book.runners.forEach((itm)=>{
                        if(itm.selectionId === dt.selectionId){
                            price = itm[dt.bet_for][0].price;
                        }
                    })
                    dt.price = price;
                    this.props.addBet(dt)
                }, DemoBetDelay);
        } else {
            this.props.addBet(dt)
        }
    }

    render() {
        let event = this.props.event
        let is_active = !!this.state.market && this.state.market.status === "OPEN"
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return <>
            <div className="w-100 pt-1">
                <div className="meventtitle" onClick={() => { this.props.history.push("/event/" + this.props.gameCode + "/" + event.id); }}>
                    <span className="lvnow"></span>{event.name}
                    {/* <span className="livenow ml-2">Live Now</span> */}
                </div>
                <div className="livenow ml-2 livenownew">Live Now</div>
                <div className="d-inline float-right">
                    {!!SPECIFICCOMPETITIONID && this.props.event.competitionId === SPECIFICCOMPETITIONID &&
                        <span className="l-tv">
                            <img className='h-22px' alt="virtual" src={BASE_IMAGE_PATH + "/uimg/game-icon.svg"} />
                        </span>
                    }
                    {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasTv && this.state.evtMeta.hasTv === 'true' && <span className="l-tv">
                        <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/tv.svg"} />
                    </span>}
                    {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasSpecial && this.state.evtMeta.hasSpecial === 'true' && <span className="p-fancy"></span>}
                    {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasBookMaker && this.state.evtMeta.hasBookMaker === 'true' && <span className="bm1"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/bm-icon1.svg"} /></span>}
                    {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasSession && this.state.evtMeta.hasSession === 'true' && <span className="fancy1 mr-1"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/fancy-icon1.svg"} /></span>}
                </div>
            </div>
            <div className="w-100">
                <div className="mtitle " onClick={() => { this.props.history.push(event.id === "28127348" ? "/ipl" : "/event/" + this.props.gameCode + "/" + event.id); }}>
                    <span><i className="flaticon-clock"></i> <span>{this.formatDate(event.openDate) + " |"}</span> {event["compititionName"]}</span>
                </div>
                {(!!accData && Object.keys(accData).length > 0) && <div className="col-info d-inline-flex float-right mr-1"><a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(this.state.market.marketId); }} className={this.props.pinnedEvents.indexOf(this.state.market.marketId) > -1 ? "add-pin-d select-pin-d" : "add-pin-d select-pind"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a></div>}
            </div>
            <table className="table w-100 game-list-col mb-1">
                <tbody>
                    {/* <tr>
                        <td className="text-center bt-0 w33 border-bt-0">1</td>
                        <td className="text-center bt-0 w33 border-bt-0">x</td>
                        <td className="text-center bt-0 w33 border-bt-0">2</td>
                    </tr> */}
                    <tr>
                        <td className="col-home border-bt-0">
                            <div className={this.state.market.status === "OPEN" ? "" : "suspended-full"} >
                                <a id="btnBack" className="btn-back" side="Back" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.selectBid(!!this.state.teams[0] ? this.state.teams[0].name : "Team 1", this.state.market.runners[0].back[0].price, this.props.gameCode, "back", event.id, this.state.teams[0]) }} style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].back[0] && this.state.market.runners[0].back[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].back[0] && is_active ? this.state.market.runners[0].back[0].price : ""}</div>
                                </a>
                                <a id="btnLay" className="btn-lay" side="Lay" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.selectBid(!!this.state.teams[0] ? this.state.teams[0].name : "Team 1", this.state.market.runners[0].lay[0].price, this.props.gameCode, "lay", event.id, this.state.teams[0]) }} style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].lay[0] && this.state.market.runners[0].lay[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].lay[0] && is_active ? this.state.market.runners[0].lay[0].price : ""}</div>
                                </a>
                            </div>
                        </td>
                        <td className="col-draw border-bt-0">
                            <div className={this.state.market.status === "OPEN" ? "" : "suspended-full"} >
                                <a id="btnBack" className="btn-back " side="Back" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.selectBid("The Draw", this.state.market.runners[2].back[0].price, this.props.gameCode, "back", event.id, this.state.teams[2]) }} style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.state.market.runners[2].back[0] && this.state.market.runners[2].back[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.state.market.runners[2].back[0] && is_active ? this.state.market.runners[2].back[0].price : ""}</div>
                                </a>
                                <a id="btnLay" className="btn-lay" side="Lay" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.selectBid("The Draw", this.state.market.runners[2].back[0].price, this.props.gameCode, "lay", event.id, this.state.teams[2]) }} style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.state.market.runners[2].lay[0] && this.state.market.runners[2].lay[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 2 && !!this.state.market.runners[2] && this.state.market.runners[2].lay[0] && is_active ? this.state.market.runners[2].lay[0].price : ""}</div>
                                </a>
                            </div>
                        </td>
                        <td className="col-visit border-bt-0">
                            <div className={this.state.market.status === "OPEN" ? "" : "suspended-full"} >
                                <a id="btnBack" className="btn-back " side="Back" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.selectBid(!!this.state.teams[1] ? this.state.teams[1].name : "Team 2", this.state.market.runners[1]?.back[0].price, this.props.gameCode, "back", event.id, this.state.teams[1]) }} style={!!this.state.market && !!this.state.market.runners && this.state.market.runners[1]?.back[0] && this.state.market.runners[1]?.back[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners[1]?.back[0] && is_active ? this.state.market.runners[1]?.back[0].price : ""}</div>
                                </a>
                                <a id="btnLay" className="btn-lay " side="Lay" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.selectBid(!!this.state.teams[1] ? this.state.teams[1].name : "Team 2", this.state.market.runners[1]?.back[0].price, this.props.gameCode, "lay", event.id, this.state.teams[1]) }} style={!!this.state.market && !!this.state.market.runners && this.state.market.runners[1]?.lay[0] && this.state.market.runners[1]?.lay[0].has_blink ? { background: "gold" } : null}>
                                    <div style={{ minHeight: "13px" }}> {!!this.state.market && !!this.state.market.runners && this.state.market.runners[1]?.lay[0] && is_active ? this.state.market.runners[1]?.lay[0].price : ""}</div>
                                </a>
                            </div>
                        </td>
                    </tr>
                    {this.props.selected_game_code === this.props.gameCode && this.props.selected_event_code === event.id &&
                        <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={this.state.eventMarket} market={this.state.market} selcted_bet_option={this.state.bid_for} addBet={(data) => { this.addBetFn(data, event) }} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={(game, event) => { this.props.betForm(game, event) }} />
                    }
                </tbody>
            </table>
            <div className="border-bottom-1">&nbsp;</div>
        </>
    }
}